import React from "react";
import PropTypes from "prop-types";
import LineItem from "./LineItem";
import Notification from "../../components/Notification";
import Spinner from "../Spinner";
import withTranslation from "../translation";
import ReservationMessage from "./ReservationMessage";
import TransitionList from "../TransitionList";

import styles from "./index.css";
import { APP_ROUTES } from "../../constants";

export const firstTwentyItems = items => items.slice(0, 20);

const MiniBag = ({
  defaultStoreUrl,
  bagItemDeleteTransitionEnd,
  formatTranslation,
  items,
  lang,
  loading
}) => {
  const moreThanTwentyItems = items.length > 20;
  const loaded = items.length && !loading;
  const itemsToRender = firstTwentyItems(items);
  const showMessagePartOne = () => {
    const languagesWithoutMessagePartOne = ["nl-NL", "sv-SE", "it-IT"];
    return !languagesWithoutMessagePartOne.includes(lang);
  };

  return loaded ? (
    <React.Fragment>
      <ReservationMessage />
      <div className={styles.miniBag}>
        <TransitionList
          onTransitionEnd={bagItemDeleteTransitionEnd}
          itemDeletedLabel={formatTranslation("minibag_itemdeleted")}
        >
          {itemsToRender.map(item => (
            <LineItem
              key={item.id}
              {...item}
              defaultStoreUrl={defaultStoreUrl}
            />
          ))}
        </TransitionList>
        {moreThanTwentyItems && (
          <Notification
            type="alert"
            withClose
            closeLabel={formatTranslation(
              "minibag_dismiss_notification_btn_text"
            )}
          >
            <div className={styles.notification}>
              <span>
                {formatTranslation("minibag_footer_maximum_items_message")}
              </span>
              <span>
                {showMessagePartOne() &&
                  formatTranslation("minibag_footer_view_bag_message_part_one")}
                <a
                  className={styles.link}
                  href={defaultStoreUrl.concat(APP_ROUTES.BAG_LINK)}
                >
                  {formatTranslation("minibag_footer_view_bag_message_link")}
                </a>
                {formatTranslation("minibag_footer_view_bag_message_part_two")}
              </span>
            </div>
          </Notification>
        )}
      </div>
    </React.Fragment>
  ) : (
    <div className={styles.spinnerContainer}>
      <Spinner size="large" />
    </div>
  );
};

MiniBag.propTypes = {
  defaultStoreUrl: PropTypes.string.isRequired,
  bagItemDeleteTransitionEnd: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  items: PropTypes.array,
  lang: PropTypes.string,
  loading: PropTypes.bool
};

MiniBag.defaultProps = {
  items: [],
  loading: false
};

export default withTranslation(MiniBag);
